import initSelectSort from './initSelectSort';
import initObfuscateLink from './initObfuscateLink';
import initSelectedTopFacets from './initSelectedTopFacets';
import initBrandModelTopFacets from './initBrandModelTopFacets';
import initProductsContainer from './initProductsContainer';
import initSidebarWidget from './initSidebarWidget';

const initProductSearch = () => {
  initSelectSort();
  initObfuscateLink();
  initSelectedTopFacets();
  initBrandModelTopFacets();
  initProductsContainer();
  initSidebarWidget();
};

export default initProductSearch;
